<template>
  <div class="container">
    <h1 class="center-text">
      {{ title }}
      <span v-if="is_valid === false" class="invalid-tag">未入力項目あり</span>
    </h1>

    <!-- Navigation links for sub-pages -->
    <nav class="nav nav-container nav-underline">

      <router-link class="nav-link" :to="`/forsales/sales_lists/${sales_list_id}/sales_lists_details`">
        {{ $t('SalesListsDetailsLayout.company_list') }}</router-link>

      <router-link class="nav-link" :to="`/forsales/sales_lists/${sales_list_id}/sales_lists_details/import`">
        {{ $t('SalesListsDetailsLayout.csv_import') }}</router-link>

      <!-- todo: how to get the detail_id for edit? -->
      <router-link class="nav-link" :to="`/forsales/sales_lists/${sales_list_id}/sales_lists_details/setting`">
        {{ $t('SalesListsDetailsLayout.company_setting') }}</router-link>

    </nav>
    <br>
    <br>

    <!-- Here, the child components will be rendered -->
    <router-view></router-view>
  </div>

</template>

<script>
import { useRoute } from "vue-router";
import { onMounted, ref } from "vue";
import { salesListsApi } from "@/api/forsales_index";

export default {
  setup() {
    const route = useRoute();
    const sales_list_id = ref(null);
    const title = ref("");
    const is_valid = ref(true);

    onMounted(async () => {
      sales_list_id.value = route.params.sales_list_id;
      console.log("sales_list_id.value:", sales_list_id.value)

      const resp = await salesListsApi.getList_1(sales_list_id.value)
      title.value = resp.data.list_name;
      is_valid.value = resp.data.is_valid;
    });

    return {
      sales_list_id,
      title,
      is_valid
    }

  }
}
</script>

<style scoped>
.center-text {
  text-align: center;
}

.nav-container {
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
}

.font-color {
  color: rgb(0, 0, 0);
}

.nav-link {
  margin: 0 10px;
  color: black;
}

.nav-link:hover {
  color: skyblue;
}

.container {
  margin-bottom: 100px;
}

.modal {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  /* 背景を半透明の黒に */
  z-index: 1000;
  /* 他の要素より前面に */
}

.modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 5px;
  width: 80%;
  /* お好みに合わせて変更 */
  max-width: 500px;
  /* お好みに合わせて変更 */
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.modal-content button {
  margin-bottom: 10px;
  /* ボタンの間隔を追加 */
}

.invalid-tag {
  display: inline-block;
  margin-left: 16px;
  padding: 2px 10px;
  background: #ffcccc;
  color: #cc0000;
  border-radius: 8px;
  font-size: 0.3em;
  font-weight: bold;
  vertical-align: middle;
}
</style>
